// @ts-nocheck
// Exact live (2026-10-15) version restored from the production sourcemap.
// export const months = [
//     { value: 'January', label: 'January' },
//     { value: 'February', label: 'February' },
//     { value: 'March', label: 'March' },
//     { value: 'April', label: 'April' },
//     { value: 'May', label: 'May' },
//     { value: 'June', label: 'June' },
//     { value: 'July', label: 'July' },
//     { value: 'August', label: 'August' },
//     { value: 'September', label: 'September' },
//     { value: 'October', label: 'October' },
//     { value: 'November', label: 'November' },
//     { value: 'December', label: 'December' }
// ];
export const months = Array.from({ length: 12 }, (_, index) => ({
    // Portal UI is English: do not use the browser locale for month names.
    label: new Date(0, index).toLocaleString('en', { month: 'long' }),
    value: (index + 1).toString()
}));
export const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];
export const year = [
    {
        label: '2024',
        value: '2024'
    },
    {
        label: '2023',
        value: '2023'
    }
];
export const getColorAndBackground = (status) => {
    switch (status) {
        case 'Unavailable':
            return { color: '#492A2A', background: '#FDBCBC' };
        case 'Rejected':
            return { color: '#492A2A', background: '#FDBCBC' };
        case 'Disapproved':
            return { color: '#492A2A', background: '#FDBCBC' };
        case 'Open':
            return { color: '#49402A', background: '#FDEDBC' };
        case 'Basic user':
            return { color: '#49402A', background: '#FDEDBC' };
        case 'Premium user':
            return { color: '#3E8291', background: '#EAFDFF' };
        case 'Pending':
            return { color: '#3E8291', background: '#EAFDFF' };
        case 'New':
            return { color: '#3E8291', background: '#EAFDFF' };
        case 'Approved':
            return { color: '#316F1D', background: '#E5FEDE' };
        case 'Complete':
            return { color: '#316F1D', background: '#E5FEDE' };
        case 'Pending Approval':
            return { color: '#C27800', background: '#FFF4E1' };
        case 'Approved Placements':
            return { color: '#1D5C84', background: '#D9F3FF' };
        case 'User Details Pending':
            return { color: '#8A3C00', background: '#FFEBD9' };
        case 'User Admin Approval':
            return { color: '#6A1B9A', background: '#F3E5F5' };
        case 'Placement Complete':
            return { color: '#316F1D', background: '#E5FEDE' };
        default:
            return { color: '#316F1D', background: '#E5FEDE' };
    }
};
